import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import type { PlaybackState } from '@/hooks/useAudioPlayback'
import { Loader2, Pause, Play, Volume2 } from 'lucide-react'

interface AudioPlaybackButtonProps {
  state: PlaybackState
  onToggle: () => void
}

const config: Record<PlaybackState, { icon: typeof Volume2; label: string }> = {
  idle: { icon: Volume2, label: 'Read aloud' },
  loading: { icon: Loader2, label: 'Loading audio...' },
  playing: { icon: Pause, label: 'Pause' },
  paused: { icon: Play, label: 'Resume' },
}

export default function AudioPlaybackButton({ state, onToggle }: AudioPlaybackButtonProps) {
  const { icon: Icon, label } = config[state]

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          onClick={onToggle}
          disabled={state === 'loading'}
          className="h-7 w-7 p-0 text-muted-foreground"
        >
          <Icon className={`h-3.5 w-3.5 ${state === 'loading' ? 'animate-spin' : ''}`} />
          <span className="sr-only">{label}</span>
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  )
}
